import quickytools from '@/components/quickytools/quickytools'
const Pricing = () => import(/* webpackChunkName: "group-company" */ '@/components/quickytools/quickytools-pricing')
const About = () => import(/* webpackChunkName: "group-company" */ '@/components/quickytools/quickytools-about')
const Support = () => import(/* webpackChunkName: "group-company" */ '@/components/quickytools/quickytools-support')
const Credits = () => import(/* webpackChunkName: "group-company" */ '@/components/quickytools/quickytools-credits')

export default [
  {
    path: '/',
    name: 'quickytools',
    component: quickytools
  },
  {
    path: '/pricing',
    component: Pricing
  },
  {
    path: '/quickytools-about',
    component: About
  },
  {
    path: '/support',
    component: Support
  },
  {
    path: '/quickytools-credits',
    component: Credits
  }
]
